import { render, staticRenderFns } from "./exhibition-template-new-brand.vue?vue&type=template&id=7ac6167b&scoped=true&"
import script from "./exhibition-template-new-brand.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-new-brand.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-new-brand.vue?vue&type=style&index=0&id=7ac6167b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac6167b",
  null
  
)

export default component.exports